export default "/images/c17a3766b15ec61fdab3e6aba2c7878d.avif";